import { StyleSheet } from 'react-native';

export const UnvalidatedStyles = {
  listHeight: 120,
};

export const Styles = StyleSheet.create({
  removeButtonPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'white',
    width: 24,
    height: 24,
    margin: 4,
    borderRadius: 12,
  },
  removeButtonIcon: {
    width: 24,
    height: 24,
    padding: 2,
  },
});
